import { Box, Text, Link, Image } from '@chakra-ui/react';
import { ArrowForwardIcon, ChevronDownIcon } from '@chakra-ui/icons';
import useTranslation from 'next-translate/useTranslation';
import NextLink from 'next/link';

const HeaderMobile = () => {
  const { t } = useTranslation('common');
  return (
    <>
      <Box display={{ base: 'block', lg: 'flex' }} justifyContent="space-between" mb={'50px'}>
        <Box
          w={{ base: '100%', lg: '49%' }}
          display={{ base: 'block', sm: 'flex' }}
          marginBottom={{ base: '25px', lg: '0' }}
        >
          <Box w={{ base: '100%', sm: '50%' }}>
            <Image w="100%" h="100%" objectFit="cover" src="/assets/gift.jpg" alt="Gift packaging"></Image>
          </Box>
          <Box
            w={{ base: '100%', sm: '50%' }}
            display="flex"
            alignItems="center"
            justifyContent="center"
            backgroundColor="#F9F9F9"
            p="60px 0"
          >
            <Box w="65%">
              <Text as="p" fontWeight="normal" fontSize="26px" lineHeight=" 33px" paddingBottom="35px">
                {t('form:giftWrap')}
              </Text>
              <Text as="p" fontWeight="normal" fontSize="14px" lineHeight=" 18px">
                {t('ShippingReturnsText')}.
              </Text>

              <NextLink href={'node/10'} passHref prefetch={false}>
                <Link textStyle={'productInfoLink'}>
                  {' '}
                  {t('more')} <ArrowForwardIcon />
                </Link>
              </NextLink>
            </Box>
          </Box>
        </Box>
        <Box
          w={{ base: '100%', lg: '49%' }}
          display="flex"
          alignItems="center"
          justifyContent="center"
          backgroundColor="#F9F9F9"
          p="60px 0"
        >
          <Box w="65%">
            <Text as="p" fontWeight="normal" fontSize="26px" lineHeight=" 33px" paddingBottom="35px">
              {'Express Delivery'}
            </Text>
            <Text as="p" fontWeight="normal" fontSize="14px" lineHeight=" 18px">
              {t('expressDeliveryText')}
            </Text>
            <NextLink href={'node/1834'} passHref prefetch={false}>
              <Link textStyle={'productInfoLink'}>
                {' '}
                {t('more')} <ArrowForwardIcon />
              </Link>
            </NextLink>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default HeaderMobile;
